var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userinfo2"},[_c('b',[_vm._v(_vm._s(_vm.item.NChart))]),_vm._v(" - "+_vm._s(_vm.item.FName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }